import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "block organizations" }
const _hoisted_2 = {
  key: 0,
  class: "menu"
}
const _hoisted_3 = { class: "message" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Nav),
    _createElementVNode("main", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("h1", null, "組織", -1)),
      (_ctx.editAccount)
        ? (_openBlock(), _createElementBlock("nav", _hoisted_2, [
            _createVNode(_component_router_link, { to: { name: 'Accounts' } }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: "edit" }),
                _cache[1] || (_cache[1] = _createElementVNode("span", null, "アカウント管理", -1))
              ]),
              _: 1,
              __: [1]
            }),
            (_ctx.loginedUser?.role == _ctx.AccountRole.SUPER_ADMIN)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/upload-json-file"
                }, {
                  default: _withCtx(() => [
                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "label" }, "JSONアップロード", -1)),
                    _createVNode(_component_font_awesome_icon, { icon: "upload" })
                  ]),
                  _: 1,
                  __: [2]
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_Table, {
        data: _ctx.data,
        headers: _ctx.headers,
        linkCols: _ctx.linkCols,
        newUri: _ctx.newUri,
        newCaption: _ctx.newCaption
      }, null, 8, ["data", "headers", "linkCols", "newUri", "newCaption"])
    ]),
    _createVNode(_component_Dialog, {
      ref: "error",
      class: "dialog"
    }, {
      default: _withCtx(() => [
        _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "title" }, "Error", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.error.message), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "btn btn-light",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.errorClose && _ctx.errorClose(...args)))
          }, "Close")
        ])
      ]),
      _: 1,
      __: [4]
    }, 512)
  ], 64))
}